import { render, staticRenderFns } from "./indexPro.vue?vue&type=template&id=16c1dd98"
import script from "./indexPro.vue?vue&type=script&lang=js"
export * from "./indexPro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports